import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

const DEMOGRAPHIC_FIELDS = ["ethnicity", "nationality", "birthplace", "age", "gender_pronouns", "height", "weight"];
const PERSONALITY_FIELDS = [
  { key: "attitude", label: "Attitude" },
  { key: "ideals", label: "Ideals" },
  { key: "likes", label: "Likes" },
  { key: "dislikes", label: "Dislikes" },
  { key: "catchphrases", label: "Catchphrases" },
  { key: "deity_or_philosophy", label: "Deity or Philosophy" },
  { key: "anathema", label: "Anathema" },
];
const CAMPAIGN_FIELDS = [
  { key: "notes", label: "Notes" },
  { key: "allies", label: "Allies" },
  { key: "enemies", label: "Enemies" },
  { key: "organizations", label: "Organizations" },
];

export default function SheetBioSection({ character, patchChar }) {
  const bio = character.bio || {};
  const campaign = character.campaign_notes || {};
  const setBio = (key, value) => patchChar({ bio: { ...bio, [key]: value } });
  const setCampaign = (key, value) => patchChar({ campaign_notes: { ...campaign, [key]: value } });

  return (
    <div className="space-y-4">
      <div>
        <p className="text-[10px] uppercase text-[#f1e0c5]/40 mb-1.5">Origin &amp; Appearance</p>
        <div className="grid grid-cols-2 gap-1.5 mb-1.5">
          {DEMOGRAPHIC_FIELDS.map((f) => (
            <Input
              key={f}
              data-testid={`bio-${f}-input`}
              placeholder={f.replace(/_/g, " ")}
              value={bio[f] || ""}
              onChange={(e) => setBio(f, e.target.value)}
              className="bg-black/30 border-white/10 h-8 text-xs capitalize"
            />
          ))}
        </div>
        <Textarea data-testid="bio-appearance-input" placeholder="Appearance" value={bio.appearance || ""} onChange={(e) => setBio("appearance", e.target.value)} className="bg-black/30 border-white/10 text-xs min-h-16" />
      </div>

      <div>
        <p className="text-[10px] uppercase text-[#f1e0c5]/40 mb-1.5">Personality</p>
        <div className="space-y-1.5">
          {PERSONALITY_FIELDS.map((f) => (
            <Textarea
              key={f.key}
              data-testid={`bio-${f.key}-input`}
              placeholder={f.label}
              value={bio[f.key] || ""}
              onChange={(e) => setBio(f.key, e.target.value)}
              className="bg-black/30 border-white/10 text-xs min-h-10"
            />
          ))}
        </div>
      </div>

      <div>
        <p className="text-[10px] uppercase text-[#f1e0c5]/40 mb-1.5">Campaign Notes</p>
        <div className="space-y-1.5">
          {CAMPAIGN_FIELDS.map((f) => (
            <Textarea
              key={f.key}
              data-testid={`campaign-${f.key}-input`}
              placeholder={f.label}
              value={campaign[f.key] || ""}
              onChange={(e) => setCampaign(f.key, e.target.value)}
              className="bg-black/30 border-white/10 text-xs min-h-10"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
